export default __webpack_public_path__ + "static/media/vendor.b7afa222.svg";